import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useUndoCreditDispensation(): UseMutationResult<
  AxiosResponse,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const undoCreditDispensation = (creditDispensationId: string): Promise<AxiosResponse> => {
    return client.post(`credit-dispensations/${creditDispensationId}/undo-rollover/`);
  };

  return useMutation(undoCreditDispensation, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['creditDispensations'],
      });
      queryClient.invalidateQueries({
        queryKey: ['athletePackages'],
      });
    },
  });
}
